import Vue from 'vue';

export default class ChatHub extends Vue {
  connection: any = null;
  startedPromise: any = null;

  constructor(connection: any, startedPromise: any) {
    super();
    this.connection = connection;
    this.startedPromise = startedPromise;
  }

  unreadMessagesCount = (currentUserId: any, hubMethod = 'UnreadMessagesCount') => {
    return this.startedPromise.then(() =>
      this.connection.invoke(hubMethod, currentUserId)
    );
  };

  unreadTechRequestMessagesCount = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection.invoke('UnreadTechRequestMessagesCount', currentUserId)
    );
  };

  sendMessage = (message: any) => {
    return this.startedPromise.then(() =>
      this.connection.invoke('SendMessage', message)
    );
  };

  loadMessages = (
    isTechnical: boolean,
    isAdministrator: boolean,
    currentUserId: any,
    selectedUserId: any
  ) => {
    let hubMethod = isTechnical ? 'LoadTechnicalMessages' : 'LoadMessages';
    if(isAdministrator)
    {
      hubMethod = 'LoadAdministratorMessages';
    }
    return this.startedPromise.then(() =>
      this.connection
        .invoke(
          hubMethod,
          selectedUserId,
          currentUserId
        )
        .then(() =>
          this.connection.invoke(
            'MarkAsRead',
            selectedUserId,
            currentUserId,
            isTechnical,
            isAdministrator
          )
        )
    );
  };

  loadTechSupRequestMessages = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection
        .invoke('LoadTechSupRequestMessages', currentUserId)
        .then(() =>
          this.connection.invoke('MarkAsReadTechRequestMessages', currentUserId)
        )
    );
  };

  loadSystemNotificationMessages = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection
        .invoke('LoadSystemNotificationMessages', currentUserId)
        .then(() => {
          this.connection.invoke('MarkAsReadSystemNotificationMessages', currentUserId)
        }
        )
    );
  };

  loadAdministratorRequestMessages = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection
        .invoke('LoadAdministratorRequestMessages', currentUserId)
        .then(() => {
          this.connection.invoke('MarkAsReadAdministratorRequestMessages', currentUserId)
        }
        )
    );
  };

  markAsRead = (selectedUserId: any, currentUserId: any, isTechChat: any, isAdministratorChat: any) => {
    return this.startedPromise.then(() =>
      this.connection.invoke(
        'MarkAsRead',
        selectedUserId,
        currentUserId,
        isTechChat,
        isAdministratorChat
      )
    );
  };

  markAsReadTechRequestMessages = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection.invoke('MarkAsReadTechRequestMessages', currentUserId)
    );
  };

  markAsReadAdministratorRequestMessages = (currentUserId: any) => {
    return this.startedPromise.then(() =>
      this.connection.invoke('MarkAsReadAdministratorRequestMessages', currentUserId)
    );
  };
}
